import ReturnPage from "./component/returnorderPage";

const ReturnOrderFocus = () => {
  return <ReturnPage pageType="MMT" />;
};

export default ReturnOrderFocus;
